// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__vV41-","savePackageButton":"ClientWallet_savePackageButton__2L0Ng"};